import React            from 'react';
import PartnersList     from '../components/PartnersList';

export default class Partners extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabList: ['Все партнеры', 'Финансовые', 'Строительные', 'Транспортные'],
            tabType: 0
        };
    }

    tabFilter (index) {
        this.setState({ tabType: index });
    }

    renderTabList = (item, index) => {
        let tabType = this.state.tabType;

        return (
            <li key={index} className={tabType === index ? 'active' : null} onClick={this.tabFilter.bind(this, index)}><span>{item}</span></li>
        )
    };

    render() {

        const { lang } = this.props;
        const { tabList, tabType } = this.state;

        return (
            <div key="Partners" className="page page-partners">
                <div className="s-job">
                    <div className="job-head">
                        <div className="container">
                            <div className="job-info">
                                <h1 className="s-index__title">{lang.Partners_title_page}</h1>
                                <ul className="list-unstyled clearfix tab-list">
                                    {tabList.map(this.renderTabList)}
                                </ul>
                            </div>

                            <div className="job-desc row">
                                <div className="col-9">
                                    <p className="desc">
                                        {lang.Partners_desc_page}
                                    </p>
                                </div>
                                <div className="col-3">
                                    <div className="job-links">
                                        <a href="mailto:info@mover24.ru" className="link">{lang.Partners_links_link}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <PartnersList tabType={tabType} />
                </div>
            </div>
        );
    }
}